export default __webpack_public_path__ + "static/media/EuclidCircularA-SemiBold.ad1487ab.ttf";